import React, { useState } from 'react';
import { IconButton, Button, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import AdmAddActionDialog from './AdmAddActionDialog';
import styles from './AdmActionTable.module.css';

const AdmActionToolbar = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => setModalOpen(true);

  const handleCloseModal = () => setModalOpen(false);

  return (
    <React.Fragment>
      {props.inTable ? (
        <Tooltip title={'Add New Action'}>
          <IconButton
            onClick={handleOpenModal}
            data-testid="action-table-add-button"
          >
            <AddIcon titleAccess="Add action" />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          className={styles.standaloneAddActionButton}
          onClick={handleOpenModal}
        >
          Add action
          <AddIcon />
        </Button>
      )}
      <AdmAddActionDialog
        open={modalOpen}
        handleCloseModal={handleCloseModal}
        handleNewAction={props.handleNewAction}
      />
    </React.Fragment>
  );
};

export default AdmActionToolbar;
